<template>
  <section class="busca">
    <div class="sticky-top" :class="{ scrolled: scrolled }" v-if="tabs.length">
      <div class="container">
        <h1 class="d-none d-md-block" v-if="quantidade">{{ quantidade }} resultados para <strong>{{ termoPesquisa }}</strong></h1>
        <ul class="nav nav-pills float-left float-md-right mt-0 mt-md-4" v-if="tabs.length">
          <li class="nav-item" v-for="tab in tabs">
            <a class="nav-link" :class="{ active: tab.ativo }" data-toggle="pill" href="javascript:void(0)" @click="carregarPesquisaAba(tab)" role="tab">{{ tab.label }}</a>
          </li>
        </ul>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="container">
      <div class="resultado-busca">
        <div v-for="resultado in resultados">
          <div class="row">
            <div class="col-12 col-md-3 text-center" v-if="resultado.imagem && resultado.url.label == 'Download'">
              <a :href="resultado.url.link" :target="resultado.url.target">
                <img :src="resultado.imagem" alt="" class="img-fluid mb-3 mb-md-0">
              </a>
            </div>
            <div class="col-12 col-md-3 text-center" v-else>
              <a @click="$router.push(resultado.url.link)" href="javascript:void(0)" :target="resultado.url.target">
                <img :src="resultado.imagem" alt="" class="img-fluid mb-3 mb-md-0">
              </a>
            </div>
            <div class="col-12 col-md">
              <span v-html="tipoResultado(resultado.tipo)"></span>
              <span v-if="resultado.url.label == 'Download'">
                <a :href="resultado.url.link" :target="resultado.url.target">
                  <h2 v-html="resultado.titulo"></h2>
                </a>
              </span>
              <span v-else>
                <a @click="$router.push(resultado.url.link)" href="javascript:void(0)" :target="resultado.url.target">
                  <h2 v-html="resultado.titulo"></h2>
                </a>
              </span>
              <span v-html="resultado.extra"></span>
              <p v-html="resultado.texto"></p>
            </div>
            <div class="col-12 col-md-3 text-center busca-star" v-if="resultado.url.link">
              <div class="d-inline-block text-center mt-3 mt-md-0" v-if="false">
                <div class="star-rating">
                  <input type="radio" id="5-stars1" name="rating1" value="5" />
                  <label for="5-stars1" class="star"><i class="fas fa-star"></i></label>
                  <input type="radio" id="4-stars1" name="rating1" value="4" />
                  <label for="4-stars1" class="star"><i class="fas fa-star"></i></label>
                  <input type="radio" id="3-stars1" name="rating1" value="3" />
                  <label for="3-stars1" class="star"><i class="fas fa-star"></i></label>
                  <input type="radio" id="2-stars1" name="rating1" value="2" />
                  <label for="2-stars1" class="star"><i class="fas fa-star"></i></label>
                  <input type="radio" id="1-star1" name="rating1" value="1" />
                  <label for="1-star1" class="star"><i class="fas fa-star"></i></label>
                </div>
              </div>
              <p class="mb-4" v-if="false">(37 classificações)</p>
              <span v-if="resultado.url.label == 'Download'">
                <a :href="resultado.url.link" :target="resultado.url.target" class="btn btn-secondary">{{ resultado.url.label }}</a>
              </span>
              <span v-else>
                <a @click="$router.push(resultado.url.link)" href="javascript:void(0)" :target="resultado.url.target" class="btn btn-secondary">{{ resultado.url.label }}</a>
              </span>
            </div>
          </div>
        </div>

        <infinite-loading ref="InfiniteLoading" :identifier="loadingId" @infinite="infiniteHandler" v-if="this.termoPesquisa">
          <div slot="no-results">Sua busca não retornou resultados</div>
          <div slot="no-more"></div>
        </infinite-loading>
        <div v-else>
          <p>Por favor digite algum termo a ser pesquisado na barra de busca.</p>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import BuscaAPI from '@/api/busca-api'
import InfiniteLoading from 'vue-infinite-loading'
import ImageUtils from '@/core/utils/image-utils'
import TipoResultadoBusca, { TipoResultadoBuscaUtil } from '@/core/types/tipo-resultado-busca'
import LoginUtils from '@/core/utils/login-utils'

export default {
  name: 'ResultadoBuscaView',
  components: { InfiniteLoading },
  data () {
    return {
      scrolled: false,
      pagina: 1,
      termoPesquisa: '',
      tipoPesquisa: '',
      quantidade: 0,
      resultados: [],
      loadingId: 'pesquisa-todos',
      tabs: [],
      planosIdsDoUsuario: []
    }
  },
  methods: {
    handleScroll: function (event) {
      const $elStickyTop = this.$el.querySelector('.sticky-top')
      if ($elStickyTop) {
        this.scrolled = window.scrollY > $elStickyTop.clientHeight
      }
    },

    limitarCaracteres: function (texto) {
      const limite = 500

      if (!texto || texto.length <= limite) return texto

      return texto.substring(0, limite) + '...'
    },

    destacarTermoPesquisado: function (texto) {
      if (!texto) return texto

      const termos = this.termoPesquisa.split(' ').map(item =>
        item
          .replace(/[.*+?^${}()|[\]\\]/gi, '\\$&')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/gi, '')
          .toLowerCase()
      )

      return texto.split(' ').map(item => {
        if (termos.includes(item.normalize('NFD').replace(/[\u0300-\u036f]/gi, '').toLowerCase())) {
          return `<strong>${item}</strong>`
        }
        return item
      }).join(' ')
    },

    infiniteHandler: function ($state) {
      if (this.termoPesquisa) {
        BuscaAPI.pesquisar(this.termoPesquisa, this.tipoPesquisa, process.env.VUE_APP_EMPRESA_REF, this.pagina, null, this.planosIdsDoUsuario).then(data => {
          this.quantidade = data._meta.total_resultados

          if (!this.tipoPesquisa) {
            if (data._meta.tipos && data._meta.tipos.length) {
              const tabTodos = [{ nome: 'todos', ativo: true, label: 'Todos' }]
              const tiposResultados = data._meta.tipos
                .filter(item => this.filtraTipos(item))
                .map(item => {
                  const tipoResultado = TipoResultadoBuscaUtil.obterPorReferencia(item)
                  return { nome: item, ativo: false, label: tipoResultado.nome, ordem: tipoResultado.id }
                })
              this.tabs = tabTodos.concat(tiposResultados).sort((value1, value2) => value1.ordem - value2.ordem)
            }
          }
          if (this.pagina <= Math.ceil(data._meta.total_paginas)) {
            this.pagina += 1
            this.adicionarResultadoPesquisa(data.data)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
      }
    },
    filtraTipos (tipo) {
      switch (tipo) {
        case TipoResultadoBusca.IMAGENS.referencia:
          return false
        case TipoResultadoBusca.DISCIPLINAS.referencia:
          return false
        case TipoResultadoBusca.SISTEMAS.referencia:
          return false
        case TipoResultadoBusca.CATEGORIAS.referencia:
          return false
        default:
          return true
      }
    },
    adicionarResultadoPesquisa: function (resultados) {
      resultados = resultados.filter(item => item.tipo !== TipoResultadoBusca.IMAGENS.referencia)

      this.resultados.push(...resultados.map(item => {
        let resultado = { id: item.id, tipo: item.tipo, url: { target: '_self', label: 'Visualizar' } }

        if (item.tipo === TipoResultadoBusca.CATEGORIAS.referencia) {
          resultado.url.link = `/cursos/categoria/${item.id}`
          resultado.titulo = this.destacarTermoPesquisado(item.categoria)
          resultado.texto = `Cursos disponíveis na categoria ${item.categoria}`
          resultado.imagem = item.imagem_url ? ImageUtils.obterUrlCompletaImagem(`${item.imagem_url}`, 'categorias-app/') : null
        } else if (item.tipo === TipoResultadoBusca.DISCIPLINAS.referencia) {
          resultado.url.link = `/disciplina/${item.disciplina_referencia}`
          resultado.titulo = this.destacarTermoPesquisado(item.disciplina)
          resultado.texto = `Cursos disponíveis da disciplina ${item.disciplina}`
          resultado.imagem = item.imagem_url ? ImageUtils.obterUrlCompletaImagem(`${item.imagem_url}`, 'disciplinas-app/') : null
        } else if (item.tipo === TipoResultadoBusca.SISTEMAS.referencia) {
          resultado.url.link = `/sistema/${item.sistema_referencia}`
          resultado.titulo = this.destacarTermoPesquisado(item.sistema)
          resultado.texto = `Cursos disponíveis do ${item.sistema}`
          resultado.imagem = item.imagem_url ? ImageUtils.obterUrlCompletaImagem(`${item.imagem_url}`, 'sistemas-app/') : null
        } else if (item.tipo === TipoResultadoBusca.CURSOS.referencia) {
          resultado.url.link = `/sala-de-aula/${item.curso_referencia}`
          resultado.titulo = this.destacarTermoPesquisado(item.curso)
          resultado.texto = item.curso_descricao
          if (item.imagem_url) resultado.imagem = ImageUtils.obterUrlCompletaImagem(item.imagem_url, 'cursos-plataforma/')
        } else if (item.tipo === TipoResultadoBusca.VIDEOS.referencia) {
          resultado.titulo = this.destacarTermoPesquisado(item.topico)

          if (item.curso_referencia && item.modulo_referencia && item.licao_referencia && item.topico_referencia) {
            resultado.url.link = `/sala-de-aula/${item.curso_referencia}/${item.modulo_referencia}/${item.licao_referencia}/${item.topico_referencia}`
          }

          resultado.extra = this.criarBreadcrumbResultado(item)

          if (item.imagem_url) resultado.imagem = ImageUtils.obterUrlCompletaImagem(item.imagem_url, 'cursos-plataforma/')

          resultado.texto = item.topico_descricao
        } else if (item.tipo === TipoResultadoBusca.QUESTOES.referencia) {
          if (item.ordem && item.licao) {
            resultado.titulo = `Questão ${item.ordem} - ${item.licao}`
          } else {
            resultado.titulo = this.destacarTermoPesquisado(item.questao)
          }

          if (item.curso_referencia && item.modulo_referencia && item.licao_referencia && item.topico_referencia) {
            resultado.url.link = `/sala-de-aula/${item.curso_referencia}/${item.modulo_referencia}/${item.licao_referencia}/${item.topico_referencia}`
          }

          resultado.extra = this.criarBreadcrumbResultado(item)

          if (item.imagem_url) resultado.imagem = ImageUtils.obterUrlCompletaImagem(item.imagem_url, 'cursos-plataforma/')

          resultado.texto = item.enunciado
        } else if (item.tipo === TipoResultadoBusca.IMAGENS.referencia) {
          resultado.titulo = this.destacarTermoPesquisado(item.topico)
          if (item.curso_referencia && item.modulo_referencia && item.licao_referencia && item.topico_referencia) {
            resultado.url.link = `/sala-de-aula/${item.curso_referencia}/${item.modulo_referencia}/${item.licao_referencia}/${item.topico_referencia}`
          }

          resultado.extra = this.criarBreadcrumbResultado(item)

          if (item.imagem_url) resultado.imagem = ImageUtils.obterUrlCompletaImagem(item.imagem_url, 'questoes-imagem/')

          resultado.texto = item.topico_descricao
        } else if (item.tipo === TipoResultadoBusca.RESUMOS.referencia) {
          resultado.titulo = this.destacarTermoPesquisado(item.resumo)
          if (item.resumo_url) {
            resultado.url = { target: '_blank', link: ImageUtils.obterUrlCompletaImagem(`${item.resumo_url}`, 'apostila-web/'), label: 'Download' }
          }

          resultado.extra = this.criarBreadcrumbResultado(item)

          if (item.imagem_url) resultado.imagem = ImageUtils.obterUrlCompletaImagem(item.imagem_url, 'cursos-plataforma/')

          resultado.texto = item.curso_descricao
        }

        resultado.texto = this.destacarTermoPesquisado(this.limitarCaracteres(resultado.texto))

        return resultado
      }))
    },

    criarBreadcrumbResultado: function (resultado) {
      let breadcrumb = []
      if (resultado.curso) breadcrumb.push(resultado.curso)
      if (resultado.modulo) breadcrumb.push(resultado.modulo)
      if (resultado.licao) breadcrumb.push(resultado.licao)
      return this.destacarTermoPesquisado(breadcrumb.join(' > ').replace(/(<([^>]+)>)/ig, ''))
    },

    carregarPesquisaAba: function (tab) {
      if (this.tipoPesquisa !== tab.nome) {
        this.resultados = []
        this.pagina = 1
        this.tipoPesquisa = tab.nome === 'todos' ? '' : tab.nome

        this.tabs.forEach(item => {
          item.ativo = item === tab
        })

        this.loadingId = 'pesquisa-' + tab.nome
      }
    },
    tipoResultado: function (tipo) {
      switch (tipo) {
        case 'video':
          return '<i class="fas fa-play"></i> VÍDEO'
        case 'questao':
          return '<i class="fas fa-question"></i> QUESTÃO'
        case 'curso':
          return '<i class="fas fa-list-ul"></i> CURSO'
        case 'disciplina':
          return '<i class="fas fa-puzzle-piece"></i> DISCIPLINA'
        case 'sistema':
          return '<i class="fas fa-dice-d20"></i> SISTEMA'
        case 'categoria':
          return '<i class="fas fa-sitemap"></i> CATEGORIA'
        case 'resumo':
          return '<i class="fas fa-arrow-alt-circle-down mr-1"></i> RESUMO'
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
    this.termoPesquisa = this.$route.query.q
  },
  watch: {
    '$store.getters.termoBuscaGeralPlataforma': async function () {
      this.pagina = 1
      this.quantidade = 0
      this.resultados = []
      this.$refs.InfiniteLoading.stateChanger.reset()
      this.termoPesquisa = this.$store.getters.termoBuscaGeralPlataforma
    }
  },
  mounted () {
    const user = LoginUtils.getUsuario()
    const planosIds = user.planos.map(item => {
      return item.idPlanoUsuario
    })

    this.planosIdsDoUsuario = planosIds
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>

</style>
